import React, { useState } from "react";
import { Grid, Icon, Menu, Card, Accordion } from "semantic-ui-react";
import Changelog from "../../Version/changelog.json";
import ContentMEP from "components/ContentMEP";
import LanguageSwitcher from "features/Admin/components/LanguageSwitcher";
import { useTranslation, Trans } from "react-i18next";

const Issues = (props) => {
	const [changelog] = useState(Changelog);
	const [activeItem, setActiveItem] = useState();
	const [activeIndex, setActiveIndex] = useState();
	const { i18n } = useTranslation();
	const getActiveLanguage = () => i18n.language || "fr";
	const changeLanguage = (lng) => {
		i18n.changeLanguage(lng);
	};

	const lang = getActiveLanguage();

	const handleClick = (e, titleProps) => {
		const { index } = titleProps;
		const newIndex = activeIndex === index ? -1 : index;

		setActiveIndex(newIndex);
	};

	const refs = changelog.releases.reduce((acc, value) => {
		const version = Object.values(value)[0];
		acc[version.version] = React.createRef();
		return acc;
	}, {});

	const handleClickScroll = (id) =>
		refs[id].current.scrollIntoView({
			behavior: "smooth",
			block: "center",
		});

	return (
		<Grid
		// textAlign='left'
		// style={ styles.gridBlock}
		// verticalAlign='top'
		>
			<Grid.Row column={2}>
				<Grid.Column width={"3"}>
					<Menu vertical fluid style={styles.menu}>
						{changelog.releases.map((object, key) => {
							const version = Object.values(object)[0];
							return (
								<Menu.Item>
									<Accordion>
										<Accordion.Title active={activeIndex === key} index={key} onClick={handleClick}>
											<Menu.Header>
												<Icon name="dropdown" color="blue" />
												{version.version}
											</Menu.Header>
										</Accordion.Title>
										<Accordion.Content active={activeIndex === key}>
											<Menu.Menu>
												{version.bug.length ? (
													<Menu.Item
														name="Bugs corrigés"
														active={activeItem === "enterprise"}
														onClick={(e, { name }) => handleClickScroll(version.version)}
													/>
												) : null}
												{version.deprecated.length ? (
													<Menu.Item
														name="Améliorations"
														active={activeItem === "enterprise"}
														onClick={(e, { name }) => handleClickScroll(version.version)}
													/>
												) : null}
												{version.improved.length ? (
													<Menu.Item
														name="Fonctionnalités dépréciées"
														active={activeItem === "enterprise"}
														onClick={(e, { name }) => handleClickScroll(version.version)}
													/>
												) : null}
												{version.removed.length ? (
													<Menu.Item
														name="Fonctionnalités supprimées"
														active={activeItem === "enterprise"}
														onClick={(e, { name }) => handleClickScroll(version.version)}
													/>
												) : null}
												{version.new.length ? (
													<Menu.Item
														name="Nouvelles fonctionnalités"
														active={activeItem === "enterprise"}
														onClick={(e, { name }) => handleClickScroll(version.version)}
													/>
												) : null}
											</Menu.Menu>
										</Accordion.Content>
									</Accordion>
								</Menu.Item>
							);
						})}
					</Menu>
				</Grid.Column>
				<Grid.Column width={"13"} fluid>
					<Card fluid style={styles.cardBlock}>
						{/* <div style={styles.blocHeader}> */}
						{/*<LanguageSwitcher lang={lang} setActiveLanguage={changeLanguage}/>  */}
						<h2 style={styles.title}>
							<Trans i18nKey="version.title"></Trans>
						</h2>
						{/* </div> */}
						{/* <div style={styles.blocWhite}> */}
						{changelog.releases && changelog.releases.length > 0 && (
							<div>
								{changelog.releases.map((item, key) => (
									<ContentMEP refs={refs} key={key} lang={lang} release={item} />
								))}
							</div>
						)}

						{/* </div> */}
					</Card>
				</Grid.Column>
			</Grid.Row>
		</Grid>
	);
};

const styles = {
	blocWhite: {
		boxShadow: "0px 9px 35px -23px rgba(148,148,148,1)",
		backgroundColor: "#fff",
		padding: 20,
		borderRadius: "0 0 4px 4px",
		// overflowY: 'auto',
		height: "100%",
		width: "100%",
	},
	title: {
		color: "#6CADDF",
		fontWeight: "800",
	},
	blocHeader: {
		backgroundColor: "rgb(0, 147, 128)",
		padding: 10,
		// width: '100%',
		borderRadius: "4px 4px 0 0",
		color: "white",
	},
	cardBlock: {
		borderRadius: "20px",
		padding: 32,
		boxShadow: "15px 8px 10px #00000029",
		marginTop: "20px",
	},
	menu: {
		// position: 'sticky',
		// top: '20px',
		borderRadius: "20px",
		marginTop: "20px",
		boxShadow: "5px 8px 10px #00000029",
	},
};

export default Issues;
